import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import { paths } from '@constants/paths';
import { useTrackingContext } from '@tracking/Provider/Context';
import { useTrackSignupOnequoteSaveClicked } from '@tracking/trackingEvents';

export const useSaveForLater = () => {
  const navigate = useNavigate();
  const { trackingContexts } = useTrackingContext();
  const trackSaveClicked = useTrackSignupOnequoteSaveClicked();

  return useCallback(() => {
    trackSaveClicked({}, { contexts: trackingContexts });
    navigate(paths.saveForLater);
  }, [navigate, trackSaveClicked, trackingContexts]);
};
